import update from 'immutability-helper';

import {
  CHAT_PANEL_CLOSE,
  CHAT_PANEL_TOGGLE,
  TREASURE_PANEL_CLOSE,
  TREASURE_PANEL_TOGGLE,
  LEADERBOARD_PANEL_CLOSE,
  LEADERBOARD_PANEL_TOGGLE,
} from '../actions/types';

import {createReducer} from '../utils';

const initialState = {
  isChatPanelOpened: true,
  isTreasurePanelOpened: false,
  isLeaderboardPanelOpened: false,
  wasChatPanelOpened: true,
};

const panelNavReducer = createReducer(initialState, {
  [CHAT_PANEL_CLOSE]: state => update(state, {
    isChatPanelOpened: {$set: false},
    wasChatPanelOpened: {$set: false},
  }),
  [CHAT_PANEL_TOGGLE]: (state) => {
    const {isChatPanelOpened} = state;
    return update(state, {
      isTreasurePanelOpened: {$set: false},
      isLeaderboardPanelOpened: {$set: false},
      isChatPanelOpened: {$set: !isChatPanelOpened},
    });
  },
  [TREASURE_PANEL_CLOSE]: state => update(state, {
    isChatPanelOpened: {$set: state.wasChatPanelOpened},
    isTreasurePanelOpened: {$set: false},
  }),
  [TREASURE_PANEL_TOGGLE]: (state) => {
    const {isTreasurePanelOpened} = state;
    return update(state, {
      isChatPanelOpened: {$set: false},
      isLeaderboardPanelOpened: {$set: false},
      isTreasurePanelOpened: {$set: !isTreasurePanelOpened},
    });
  },
  [LEADERBOARD_PANEL_CLOSE]: state => update(state, {
    isChatPanelOpened: {$set: state.wasChatPanelOpened},
    isLeaderboardPanelOpened: {$set: false},
  }),
  [LEADERBOARD_PANEL_TOGGLE]: (state) => {
    const {isLeaderboardPanelOpened} = state;
    return update(state, {
      isTreasurePanelOpened: {$set: false},
      isChatPanelOpened: {$set: false},
      isLeaderboardPanelOpened: {$set: !isLeaderboardPanelOpened},
    });
  },
});

export default panelNavReducer;
